module.exports = __webpack_public_path__ + "media/56.05d9e508.mp3";